import React from 'react';
import { motion } from 'framer-motion';

export const ThreeDotLoader = () => {
  // Animation variants for the circles
  const initialScale = 1;
  const finalScale = 1.25;

  const circleVariants = {
    initial: {
      scale: initialScale,
      fill: "#0C4A6E"
    },
    animate: (i) => ({
      scale: [initialScale, finalScale, initialScale],
      fill: ["#333", "#7DD3FC", "#333"],
      transition: {
        duration: 0.6,
        ease: "easeInOut",
        times: [0, 0.5, 1],
        repeat: Infinity,
        repeatDelay: 1.1, // Wait for all circles to finish (3 * 0.6)
        delay: i * 0.6 // Stagger based on circle index
      }
    })
  };

  return (
    <motion.svg
      width="28"
      height="24"
      viewBox="0 0 34 34"
    >
      <motion.circle
        cx="4"
        cy="16"
        r="4"
        initial="initial"
        animate="animate"
        variants={circleVariants}
        custom={0} // First circle
      />
      <motion.circle
        cx="18"
        cy="16"
        r="4"
        initial="initial"
        animate="animate"
        variants={circleVariants}
        custom={1} // Second circle
      />
      <motion.circle
        cx="32"
        cy="16"
        r="4"
        initial="initial"
        animate="animate"
        variants={circleVariants}
        custom={2} // Third circle
      />
    </motion.svg>
  );
};

export const FiveDotLoader = () => {
  // Animation variants for the circles
  const initialScale = 1;
  const finalScale = 1.25;

  const circleVariants = {
    initial: {
      scale: initialScale,
      fill: "#0C4A6E"
    },
    animate: (i) => ({
      scale: [initialScale, finalScale, initialScale],
      fill: ["#333", "#7DD3FC", "#333"],
      transition: {
        duration: 0.6,
        ease: "easeInOut",
        times: [0, 0.5, 1],
        repeat: Infinity,
        repeatDelay: 1.9,
        delay: i * 0.3
      }
    })
  };

  return (
    <motion.svg
      width="60"
      height="24"
      viewBox="0 0 74 34"
    >
      <motion.circle
        cx="4"
        cy="16"
        r="4"
        initial="initial"
        animate="animate"
        variants={circleVariants}
        custom={0}
      />
      <motion.circle
        cx="18"
        cy="16"
        r="4"
        initial="initial"
        animate="animate"
        variants={circleVariants}
        custom={1}
      />
      <motion.circle
        cx="32"
        cy="16"
        r="4"
        initial="initial"
        animate="animate"
        variants={circleVariants}
        custom={2}
      />
      <motion.circle
        cx="46"
        cy="16"
        r="4"
        initial="initial"
        animate="animate"
        variants={circleVariants}
        custom={3}
      />
      <motion.circle
        cx="60"
        cy="16"
        r="4"
        initial="initial"
        animate="animate"
        variants={circleVariants}
        custom={4}
      />
    </motion.svg>
  );
};

export const StaticFiveDots = () => (
  <svg width="60" height="24" viewBox="0 0 74 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="4" cy="16" r="4" fill="#333" />
    <circle cx="18" cy="16" r="4" fill="#333" />
    <circle cx="32" cy="16" r="4" fill="#333" />
    <circle cx="46" cy="16" r="4" fill="#333" />
    <circle cx="60" cy="16" r="4" fill="#333" />
  </svg>
);
